export const ALL = 'ALL' as const;
export const UNCATEGORIZED = 'smart_form_uncategorized' as const;
